import styled from 'styled-components';

export const Container = styled.button`


width: 40px;
height: 40px;

margin: 20px 5px 10px 0;

border: 0;

background-color: #f85d00;

display: flex;
justify-content: center;
align-items: center;


&:disabled{
    opacity:0.5;
    cursor: not-allowed;
}



`;

export const Icon = styled.img`



`;
